export let _websites = require.context("../images/Websites", false, /\.(gif|jpg|jpeg|tiff|png)$/i);